import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider, // Add Facebook provider
  OAuthProvider, // Use OAuthProvider for Apple, Microsoft etc.
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  onAuthStateChanged,
  signOut
} from "firebase/auth";
// Optional: Import other Firebase services like Firestore if needed
// import { getFirestore } from "firebase/firestore";

// Determine authDomain dynamically to fix cross-origin cookie issues.
// When the hosting domain differs from firebaseapp.com, modern browsers
// (Safari ITP, Edge Tracking Prevention, Chrome 3P cookie deprecation)
// block third-party cookies from firebaseapp.com, breaking the redirect flow.
// Fix: set authDomain to the hosting domain and proxy /__/auth/* to Firebase.
const getAuthDomain = () => {
  if (typeof window === 'undefined') {
    return "eladore-b9f28.firebaseapp.com"; // SSR/test fallback
  }
  const hostname = window.location.hostname;
  // In local development, use the default Firebase authDomain (no proxy needed,
  // localhost is typically not affected by third-party cookie restrictions)
  if (hostname === 'localhost' || hostname.startsWith('192.168.')) {
    return "eladore-b9f28.firebaseapp.com";
  }
  // For production/staging, use the current domain as authDomain.
  // This requires /__/auth/* to be reverse-proxied to Firebase.
  return hostname;
};

// Your web app's Firebase configuration
// Consider using environment variables for sensitive keys like apiKey in production
const firebaseConfig = {
  apiKey: "AIzaSyAsNrUocCjsn2Ekq_rs3bBImAFi6KRwkdo",
  authDomain: getAuthDomain(),
  projectId: "eladore-b9f28",
  storageBucket: "eladore-b9f28.appspot.com", // Corrected storage bucket domain
  messagingSenderId: "644006035868",
  appId: "1:644006035868:web:625efce05504346a470859",
  measurementId: "G-DQWER284RB" // Optional
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

// Export the app for use in messaging
export { app };

// Initialize other services if needed
// const db = getFirestore(app);

// Create provider instances
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider(); // Add Facebook provider
// const appleProvider = new OAuthProvider('apple.com'); // Removed Apple provider definition
const microsoftProvider = new OAuthProvider('microsoft.com');

// Export necessary functions and instances
export {
  auth,
  // db, // Export firestore instance if used
  googleProvider,
  facebookProvider, // Export Facebook provider
  microsoftProvider,
  // appleProvider, // Removed Apple provider export
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  onAuthStateChanged,
  signOut
};